/**
 * s237 (ACROSS-YOUR-PLAN-1 PR C; D-237.34, rule 159) — ONE row of filter chips, built once for the "Across your plan"
 * pages (Contacts now; the Financial summary in stage 2). Board 12: a pill per chip with its count; the picked one in
 * sage. A chip with nobody in it is the caller's to leave out (board: "a planner with no business never sees it read 0").
 */
export function FilterChips<K extends string>({ chips, value, onChange, testId }: {
  chips: readonly { id: K; label: string; count: number }[];
  value: K;
  onChange: (id: K) => void;
  testId: string;
}) {
  return (
    <div className="flex flex-wrap gap-2" role="group" data-testid={testId}>
      {chips.map((c) => {
        const on = c.id === value;
        return (
          <button key={c.id} type="button" aria-pressed={on} onClick={() => onChange(c.id)}
            className={`flex min-h-11 items-center gap-2 rounded-full border-[1.5px] px-4 text-[14px] ${on ? "border-sage-600 bg-sage-50 text-sage-800" : "border-warm-stone bg-warm-white text-warm-charcoal hover:bg-warm-stone-light"}`}
            data-testid={`${testId}-${c.id}`}>
            <span>{c.label}</span><span className="text-[13px] text-warm-muted">{c.count}</span>
          </button>
        );
      })}
    </div>
  );
}
